import { initialState, TTopicMethods, TTopicStore } from "./topic.state";
import { topicReducer } from "./topic.reducer";
import { NormalizedTopic } from "~/types/search.types";

// ✅ Reusable store methods
export const createTopicActions = (
    set: any,
    get: () => TTopicStore
): Pick<TTopicStore, TTopicMethods> => ({
    dispatch: action => set((state: TTopicStore) => topicReducer(state, action)),

    getSelectedTopics: () => {
        const selectedTopics = get()
            .selectedTopicIds.map(uniqueTopicdId => Number(uniqueTopicdId.split("|")?.[2] || -1))
            .filter(topicId => topicId > -1);

        return selectedTopics.reduce((list: NormalizedTopic[], topicId) => {
            const topic = get().getTopicById(topicId);

            return topic ? [...list, topic] : list;
        }, []);
    },

    getTopicsByParentIDs: ({ disclosureId, categoryId }) => {
        return get().topics.filter(
            item =>
                (!disclosureId || item.disclosureId === disclosureId) &&
                (!categoryId || item.categoryId === categoryId)
        );
    },

    getTopicById: topicId => {
        return get().topics.find(item => item.exploreId === topicId);
    },

    isTopicSelected: topicId => {
        const uniqueTopicId = get().getUniqueTopicId(topicId);

        if (!uniqueTopicId) {
            return false;
        }

        return get().selectedTopicIds.includes(uniqueTopicId);
    },

    getTopicCount: topicId => {
        return get().topics.find(item => item.exploreId === topicId)?.count || 0;
    },

    getUniqueTopicId: topicId => {
        const topic = get().topics.find(item => item.exploreId === topicId);

        if (!topic) {
            return null;
        }

        const { disclosureId, categoryId, exploreId } = topic;
        return `${disclosureId}|${categoryId}|${exploreId}`;
    },

    getTopicName: id => {
        const topic = get().topics.find(item => item.exploreId === id);
        if (!topic) {
            return null;
        }
        return topic?.label || null;
    },

    reset: () => {
        set(initialState);
    }
});
